"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.awaitTransactionSignatureConfirmation = exports.sendSignedTransaction = exports.simulateTransaction = exports.sendTransaction = exports.signTransaction = exports.makeAndSendTx = exports.FriktionTransactionError = exports.TimeoutError = exports.getUnixTs = exports.sleep = void 0;
var tslib_1 = require("tslib");
function sleep(ms) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
exports.sleep = sleep;
var getUnixTs = function () {
    return new Date().getTime() / 1000;
};
exports.getUnixTs = getUnixTs;
var TimeoutError = /** @class */ (function (_super) {
    tslib_1.__extends(TimeoutError, _super);
    function TimeoutError(_a) {
        var txid = _a.txid;
        var _this = _super.call(this) || this;
        _this.message = "Timed out awaiting confirmation. Please confirm in the explorer: ";
        _this.txid = txid;
        return _this;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
var FriktionTransactionError = /** @class */ (function (_super) {
    tslib_1.__extends(FriktionTransactionError, _super);
    function FriktionTransactionError(_a) {
        var txid = _a.txid, message = _a.message;
        var _this = _super.call(this) || this;
        _this.message = message;
        _this.txid = txid;
        return _this;
    }
    return FriktionTransactionError;
}(Error));
exports.FriktionTransactionError = FriktionTransactionError;
var makeAndSendTx = function (connection, user, tx, signers, timeout) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var txSig;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, signTransaction({
                    transaction: tx,
                    payer: user,
                    signers: signers,
                    connection: connection,
                })];
            case 1:
                _a.sent();
                return [4 /*yield*/, sendSignedTransaction({
                        signedTransaction: tx,
                        connection: connection,
                        timeout: timeout !== null && timeout !== void 0 ? timeout : 60000,
                    })];
            case 2:
                txSig = _a.sent();
                return [2 /*return*/, txSig];
        }
    });
}); };
exports.makeAndSendTx = makeAndSendTx;
function signTransaction(_a) {
    var transaction = _a.transaction, payer = _a.payer, signers = _a.signers, connection = _a.connection;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = transaction;
                    return [4 /*yield*/, connection.getRecentBlockhash("confirmed")];
                case 1:
                    _b.recentBlockhash = (_c.sent()).blockhash;
                    transaction.setSigners.apply(transaction, tslib_1.__spreadArray([payer.publicKey], signers.map(function (s) { return s.publicKey; }), false));
                    if (signers.length > 0) {
                        transaction.partialSign.apply(transaction, signers);
                    }
                    if (!(payer === null || payer === void 0 ? void 0 : payer.connected)) return [3 /*break*/, 3];
                    console.log(new Date().toUTCString(), "signing as wallet", payer.publicKey);
                    return [4 /*yield*/, payer.signTransaction(transaction)];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    transaction.sign.apply(transaction, [payer].concat(signers));
                    _c.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.signTransaction = signTransaction;
// TODO - switch Account to Keypair and switch off setSigners due to deprecated
/**
 * Send a transaction using the Solana Web3.js connection on the mango client
 *
 * @param transaction
 * @param payer
 * @param additionalSigners
 * @param timeout Retries sending the transaction and trying to confirm it until the given timeout. Defaults to 30000ms. Passing null will disable the transaction confirmation check and always return success.
 */
function sendTransaction(connection, transaction, payer, additionalSigners, timeout, confirmLevel, marketName) {
    if (timeout === void 0) { timeout = 30000; }
    if (confirmLevel === void 0) { confirmLevel = "confirmed"; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rawTransaction, startTime, txid, done, retrySleep, err_1, simulateResult, e_1, i, line;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, signTransaction({
                        transaction: transaction,
                        payer: payer,
                        signers: additionalSigners,
                        connection: connection,
                    })];
                case 1:
                    _a.sent();
                    console.log(marketName);
                    rawTransaction = transaction.serialize();
                    startTime = (0, exports.getUnixTs)();
                    return [4 /*yield*/, connection.sendRawTransaction(rawTransaction
                        // { skipPreflight: true },
                        )];
                case 2:
                    txid = _a.sent();
                    // if (postSendTxCallback) {
                    //   try {
                    //     postSendTxCallback({ txid });
                    //   } catch (e) {
                    //     console.log(new Date().toUTCString(), `postSendTxCallback error ${e}`);
                    //   }
                    // }
                    // console.log('checking timeout');
                    if (!timeout)
                        return [2 /*return*/, txid];
                    console.log(new Date().toUTCString(), "Started awaiting confirmation for tx: ", txid, " size:", rawTransaction.length);
                    done = false;
                    retrySleep = 17000;
                    (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(!done && (0, exports.getUnixTs)() - startTime < timeout / 1000)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, sleep(retrySleep)];
                                case 1:
                                    _a.sent();
                                    // console.log(new Date().toUTCString(), ' sending tx ', txid);
                                    connection.sendRawTransaction(rawTransaction, {
                                        skipPreflight: true,
                                    });
                                    if (retrySleep <= 6000) {
                                        retrySleep = retrySleep * 2;
                                    }
                                    return [3 /*break*/, 0];
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); })();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, 10, 11]);
                    return [4 /*yield*/, awaitTransactionSignatureConfirmation(connection, txid, timeout, confirmLevel)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 11];
                case 5:
                    err_1 = _a.sent();
                    if (err_1.timeout) {
                        throw new TimeoutError({ txid: txid });
                    }
                    simulateResult = null;
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, simulateTransaction(connection, transaction, "confirmed")];
                case 7:
                    simulateResult = (_a.sent()).value;
                    return [3 /*break*/, 9];
                case 8:
                    e_1 = _a.sent();
                    console.warn("Simulate transaction failed");
                    return [3 /*break*/, 9];
                case 9:
                    if (simulateResult && simulateResult.err) {
                        if (simulateResult.logs) {
                            for (i = simulateResult.logs.length - 1; i >= 0; --i) {
                                line = simulateResult.logs[i];
                                if (line === null || line === void 0 ? void 0 : line.startsWith("Program log: ")) {
                                    throw new FriktionTransactionError({
                                        message: "Transaction fai led: " + (line === null || line === void 0 ? void 0 : line.slice("Program log: ".length)),
                                        txid: txid,
                                    });
                                }
                            }
                        }
                        throw new FriktionTransactionError({
                            message: JSON.stringify(simulateResult.err),
                            txid: txid,
                        });
                    }
                    throw new FriktionTransactionError({ message: "Transaction failed", txid: txid });
                case 10:
                    done = true;
                    return [7 /*endfinally*/];
                case 11:
                    console.log("Latency", txid, (0, exports.getUnixTs)() - startTime);
                    return [2 /*return*/, txid];
            }
        });
    });
}
exports.sendTransaction = sendTransaction;
function simulateTransaction(connection, transaction, commitment) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var blockhash, signData, wireTransaction, encodedTransaction, config, args, res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    signData = transaction.serializeMessage();
                    wireTransaction = transaction._serialize(signData);
                    encodedTransaction = wireTransaction.toString("base64");
                    config = {
                        encoding: "base64",
                        commitment: commitment,
                        replaceRecentBlockhash: true,
                    };
                    args = [encodedTransaction, config];
                    return [4 /*yield*/, connection._rpcRequest("simulateTransaction", args)];
                case 2:
                    res = _a.sent();
                    if (res.error) {
                        throw new Error("failed to simulate transaction: " + res.error.message);
                    }
                    return [2 /*return*/, res.result];
            }
        });
    });
}
exports.simulateTransaction = simulateTransaction;
function sendSignedTransaction(_a) {
    var connection = _a.connection, signedTransaction = _a.signedTransaction, _b = _a.timeout, timeout = _b === void 0 ? 30000 : _b, _c = _a.confirmLevel, confirmLevel = _c === void 0 ? "confirmed" : _c;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rawTransaction, startTime, txid, done, err_2, simulateResult, e_2, i, line;
        var _this = this;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    rawTransaction = signedTransaction.serialize();
                    startTime = (0, exports.getUnixTs)();
                    return [4 /*yield*/, connection.sendRawTransaction(rawTransaction, {
                            skipPreflight: true,
                        })];
                case 1:
                    txid = _d.sent();
                    done = false;
                    (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, sleep(500)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (!(!done && (0, exports.getUnixTs)() - startTime < timeout)) return [3 /*break*/, 4];
                                    connection.sendRawTransaction(rawTransaction, {
                                        skipPreflight: true,
                                    });
                                    return [4 /*yield*/, sleep(1000)];
                                case 3:
                                    _a.sent();
                                    return [3 /*break*/, 2];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })();
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, 9, 10]);
                    return [4 /*yield*/, awaitTransactionSignatureConfirmation(connection, txid, timeout, confirmLevel)];
                case 3:
                    _d.sent();
                    return [3 /*break*/, 10];
                case 4:
                    err_2 = _d.sent();
                    if (err_2.timeout) {
                        throw new TimeoutError({ txid: txid });
                    }
                    simulateResult = null;
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, simulateTransaction(connection, signedTransaction, "confirmed")];
                case 6:
                    simulateResult = (_d.sent()).value;
                    return [3 /*break*/, 8];
                case 7:
                    e_2 = _d.sent();
                    console.log(new Date().toUTCString(), "Simulate tx failed", e_2);
                    return [3 /*break*/, 8];
                case 8:
                    if (simulateResult && simulateResult.err) {
                        if (simulateResult.logs) {
                            for (i = simulateResult.logs.length - 1; i >= 0; --i) {
                                line = simulateResult.logs[i];
                                if (line === null || line === void 0 ? void 0 : line.startsWith("Program log: ")) {
                                    throw new FriktionTransactionError({
                                        message: "Transaction failed: " + simulateResult.logs.join("\n"),
                                        txid: txid,
                                    });
                                }
                            }
                        }
                        throw new FriktionTransactionError({
                            message: JSON.stringify(simulateResult.err),
                            txid: txid,
                        });
                    }
                    throw new FriktionTransactionError({ message: "Transaction failed", txid: txid });
                case 9:
                    done = true;
                    return [7 /*endfinally*/];
                case 10: 
                // console.log('Latency', txid, getUnixTs() - startTime);
                return [2 /*return*/, txid];
            }
        });
    });
}
exports.sendSignedTransaction = sendSignedTransaction;
function awaitTransactionSignatureConfirmation(connection, txid, timeout, confirmLevel) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var done, confirmLevels, subscriptionId, result;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    done = false;
                    confirmLevels = [
                        "finalized",
                    ];
                    if (confirmLevel === "confirmed") {
                        confirmLevels.push("confirmed");
                    }
                    else if (confirmLevel === "processed") {
                        confirmLevels.push("confirmed");
                        confirmLevels.push("processed");
                    }
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var retrySleep;
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setTimeout(function () {
                                                if (done) {
                                                    return;
                                                }
                                                done = true;
                                                console.log(new Date().toUTCString(), "Timed out for txid: ", txid);
                                                reject({ timeout: true });
                                            }, timeout);
                                            try {
                                                subscriptionId = connection.onSignature(txid, function (result, context) {
                                                    subscriptionId = undefined;
                                                    done = true;
                                                    if (result.err) {
                                                        reject(result.err);
                                                    }
                                                    else {
                                                        // lastSlot = context?.slot;
                                                        resolve(result);
                                                    }
                                                }, "confirmed");
                                            }
                                            catch (e) {
                                                done = true;
                                                console.log(new Date().toUTCString(), "WS error in setup", txid, e);
                                            }
                                            retrySleep = 1500;
                                            console.log("polling tx ", txid);
                                            _a.label = 1;
                                        case 1:
                                            if (!!done) return [3 /*break*/, 3];
                                            // eslint-disable-next-line no-loop-func
                                            return [4 /*yield*/, sleep(retrySleep)];
                                        case 2:
                                            // eslint-disable-next-line no-loop-func
                                            _a.sent();
                                            (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                var response, result_1, e_3;
                                                return tslib_1.__generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            _a.trys.push([0, 2, , 3]);
                                                            return [4 /*yield*/, connection.getSignatureStatuses([txid])];
                                                        case 1:
                                                            response = _a.sent();
                                                            result_1 = response && response.value[0];
                                                            if (!done) {
                                                                if (!result_1) {
                                                                    // console.log("REST null result for", txid, result);
                                                                }
                                                                else if (result_1.err) {
                                                                    console.log(new Date().toUTCString(), "REST error for", txid, result_1);
                                                                    done = true;
                                                                    reject(result_1.err);
                                                                }
                                                                else if (!(result_1.confirmations ||
                                                                    confirmLevels.includes(result_1.confirmationStatus))) {
                                                                    console.log(new Date().toUTCString(), "REST not confirmed", txid, result_1);
                                                                }
                                                                else {
                                                                    // lastSlot = response?.context?.slot;
                                                                    // console.log('REST confirmed', txid, result);
                                                                    done = true;
                                                                    resolve(result_1);
                                                                }
                                                            }
                                                            return [3 /*break*/, 3];
                                                        case 2:
                                                            e_3 = _a.sent();
                                                            if (!done) {
                                                                console.log(new Date().toUTCString(), "REST connection error: txid", txid, e_3);
                                                            }
                                                            return [3 /*break*/, 3];
                                                        case 3: return [2 /*return*/];
                                                    }
                                                });
                                            }); })();
                                            if (retrySleep <= 1600) {
                                                retrySleep = retrySleep * 2;
                                            }
                                            return [3 /*break*/, 1];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })();
                        })];
                case 1:
                    result = _a.sent();
                    if (subscriptionId) {
                        connection.removeSignatureListener(subscriptionId).catch(function (e) {
                            console.log(new Date().toUTCString(), "WS error in cleanup", e);
                        });
                    }
                    done = true;
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.awaitTransactionSignatureConfirmation = awaitTransactionSignatureConfirmation;
